import React from 'react';
import { Navigate } from 'react-router-dom';

// Kept as a redirect for old /admin/schedule bookmarks. Real page lives at /admin/calendar (AdminCalendarPage).
export default function AdminSchedulePage() {
  return <Navigate to="/admin/calendar" replace />;
}
